<template>
  <form method="get" action @submit.prevent="search">
    <div class="search-wrapper">
      <input
        id="search-customer"
        v-model="query"
        v-autofocus
        aria-label="Zoek naar een klant"
        type="search"
        :placeholder="inputPlaceholderText"
        autocomplete="off"
        data-qa="search"
        @change="updateStore"
      />

      <button class="btn-submit" type="submit" data-qa="search-icon-submit">
        <span class="sr-only">Zoek naar klanten</span>
        <icon class="icon-search" icon="search" />
      </button>
    </div>
    <alert type="info" :text="infoText" />
  </form>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
import autoFocus from '@/mixins/autoFocus.js'
import StoreConnector from '@/helpers/StoreConnector'

export default {
  components: {
    Icon,
    Alert,
  },
  mixins: [autoFocus],
  props: {
    inputPlaceholderText: {
      type: String,
      default: '',
    },
    infoText: {
      type: String,
      default: '',
    },
    translations: {
      type: Object,
      default: () => {},
    },
    isVehicleCustomerSearch: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onSearch'],
  data() {
    return {
      query: '',
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  created() {
    if (!this.isVehicleCustomerSearch) {
      StoreConnector.get('customer/searchQuery', (data) => {
        this.query = data
      })
    }
  },
  unmounted() {
    this.query = ''
    if (!this.isVehicleCustomerSearch) {
      this.updateStore()
    }
  },
  methods: {
    search() {
      if (!this.isVehicleCustomerSearch) {
        StoreConnector.dispatch('customer/resetSearchResults')
      }
      this.$emit('onSearch', this.query)
    },
    updateStore() {
      StoreConnector.dispatch('customer/setSearchQuery', this.query)
    },
  },
}
</script>

<style lang="scss" scoped>
form {
  margin-bottom: 1em;
}

.search-wrapper {
  position: relative;
  margin-bottom: 0.5em;
}

input[type='search'] {
  width: 100%;
  flex: 1 1 auto;
  padding-right: 3em;
}

.btn-submit {
  $margin: 2px;

  border: 0;
  position: absolute;
  top: $margin;
  right: $margin;
  bottom: $margin;
  display: flex;
  align-items: center;
  background: $gray-lightest;
  padding: 0 0.75em;

  &:hover:not(:disabled) {
    background: $gray-light;
  }

  &[disabled] {
    color: $gray-light;
  }
}

label {
  display: block;
  margin-bottom: 0.5em;
}
</style>
